// Destructuring the Open Api JSON for Sidebar format
export const convertJSONintoPreferredSideBarFormat = (apiData)=>{
  const menu =[];
  for (const entry of Object.entries(apiData)) {
    menu.push({
      header: entry[0],
      subEntities: entry[1].SubEntities,
      schemas: entry[1].schemas,
      schemasWithRefs: entry[1].schemasWithRefs,
    });
  }
  return menu;
};

// function to decode the method name from URL format
export const decodeMethodName = (method) => {
  return method ? method.replaceAll("-", " ") : null;
};

// function to find the element by method name
export const findMethodElement = (methodName) => {
  return methodName ? document.querySelector(`[data-id="${methodName}"]`) : null;
};

// function to scroll to an element
export const scrollToElement = (element) => {
  element?.scrollIntoView({behavior: "instant", block: "start"});
};

// function to get the base path
export const getBasePath = () => {
  return location?.pathname.split("/").slice(0, 3).join("/");
};

// function to update URL with method name
export const updateUrlWithMethodName = (methodName) => {
  const formattedMethodName = methodName.replaceAll(" ", "-");
  const newPath = `${getBasePath()}#${formattedMethodName}`;
  window.history.pushState(null, null, newPath);
};
